module.exports = __webpack_public_path__ + "img/cert_04.88fed810.jpg";